import { useEffect } from "react";
import { renderHomePage } from "../../pages/home";

export function LegacyHome() {
  useEffect(() => { document.title = "PedEmUP | Çocuk Acil Eğitim Platformu"; }, []);
  return <div dangerouslySetInnerHTML={{ __html: renderHomePage() }} />;
}
